<template>
	<div id="about">
		<div>免费小程序</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
			};
		},
		methods: {
			onClick(){
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/litapp/index.vue